export default __webpack_public_path__ + "static/media/unarchive.aeb42766.svg";